import { inject, Injectable } from '@angular/core';
import {
  ChangePasswordRequest,
  CreateMemberRequest,
  CreateMemberResponse,
  SendForgetPasswordRequest,
  SendForgetPasswordResponse,
} from '../interfaces/set-password.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';
import { SKIP_AUTH } from '../tokens/http-context.tokens';

@Injectable({
  providedIn: 'root',
})
export class SetPasswordService {
  http: HttpClient = inject(HttpClient);

  /**
   * 檢核通過後新增會員
   * @param request 新增會員請求參數
   */
  createMember(
    request: CreateMemberRequest
  ): Observable<ApiResponse<CreateMemberResponse>> {
    const payload: CreateMemberRequest = request;
    return this.http.post<ApiResponse<CreateMemberResponse>>(
      API_ENDPOINTS.CREATE_MEMBER,
      payload
    );
  }

  changePassword(
    request: ChangePasswordRequest,
    forgetResetToken?: string
  ): Observable<ApiResponse<null>> {
    const payload: ChangePasswordRequest = request;

    if (forgetResetToken) {
      // if its from forget password it will get the forgetResetToken from the url param,
      // then we will skip the regular token interceptor and manually put this forgetResetToken in header
      const httpContext = new HttpContext().set(SKIP_AUTH, true);
      const httpHeader = { Authorization: `Bearer ${forgetResetToken}` };

      return this.http.patch<ApiResponse<null>>(
        API_ENDPOINTS.RESET_PASSWORD,
        payload,
        {
          headers: httpHeader,
          context: httpContext,
        }
      );
    }

    return this.http.patch<ApiResponse<null>>(
      API_ENDPOINTS.RESET_PASSWORD,
      payload
    );
  }

  sendForgetPassword(
    request: SendForgetPasswordRequest
  ): Observable<ApiResponse<SendForgetPasswordResponse>> {
    const payload: SendForgetPasswordRequest = request;
    return this.http.post<ApiResponse<SendForgetPasswordResponse>>(
      API_ENDPOINTS.FORGET_PASSWORD,
      payload
    );
  }
}
